const LISTA_BUSCA_ID = "smarthint-search";
const NOME_LISTA_VISUALIZADA = "View Item List de busca";
const NOME_ITEM_SELECIONADO = "Select Item da busca";

const FILIAIS = {
  1: "Maringá - PR",
  2: "Itajaí - SC"
};

function toNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function getValue(source, keys, fallback = "") {
  if (!source) return fallback;

  for (let i = 0; i < keys.length; i++) {
    if (source[keys[i]] !== undefined && source[keys[i]] !== null) {
      return source[keys[i]];
    }
  }

  return fallback;
}

function getAnalyticsDTOs() {
  if (typeof window === "undefined" || !window.OrquestradorAnalytics) {
    return null;
  }

  const analytics = window.OrquestradorAnalytics;
  if (!analytics.EventoDTO || !analytics.EventoItemDTO) {
    return null;
  }

  return analytics;
}

function getAnalytics() {
  if (typeof window === "undefined" || !window.OrquestradorAnalytics) {
    return null;
  }

  const analytics = window.OrquestradorAnalytics;
  if (!analytics.EventoDTO || !analytics.gerenciador) {
    return null;
  }

  return analytics;
}

function buildClickEvent({ codigoProduto, preco, termo } = {}) {
  const item = { codigoProduto, preco };
  const evento = { termo, itens: [item] };
  const analytics = getAnalyticsDTOs();

  if (!analytics) {
    return evento;
  }

  try {
    const eventoItem = new analytics.EventoItemDTO(item);
    return new analytics.EventoDTO({ termo, itens: [eventoItem] });
  } catch (e) {
    return evento;
  }
}

function send(method, payload) {
  const analytics = getAnalytics();

  if (
    !analytics ||
    !analytics.gerenciador ||
    typeof analytics.gerenciador[method] !== "function"
  ) {
    return;
  }

  try {
    const evento = new analytics.EventoDTO(payload);
    analytics.gerenciador[method](evento);
  } catch (e) {}
}

function getUser(input) {
  const user =
    input && input.state && input.state.login ? input.state.login.user : input;

  if (!user) {
    return null;
  }

  const id = user.codigo || user.id;
  const name = user.first_name || user.username || user.name;

  if (!id && !name) {
    return null;
  }

  return {
    id: id || "",
    name: name || ""
  };
}

function getFilial(filial) {
  const codigoFilial = filial || "";
  return FILIAIS[codigoFilial] || codigoFilial.toString();
}

function getPreco(item) {
  return (
    toNumber(getValue(item, ["valor_unitario", "vlPrecoUnit", "preco"])) +
    toNumber(getValue(item, ["valor_ipi", "ipi"])) +
    toNumber(getValue(item, ["valor_st", "st"]))
  );
}

function getQuantidade(item) {
  return toNumber(getValue(item, ["quantidade", "qtQuantidade"], 1));
}

function buildCatalogItem(item) {
  return {
    codigoProduto: getValue(item, ["codigoProduto", "codigo", "produto_codigo"]).toString(),
    titulo: getValue(item, ["titulo", "vcTitulo", "descricao"]),
    marca: getValue(item, ["marca", "ds_marca"]),
    categoria: getValue(item, ["categoria", "ds_categoria"])
  };
}

function buildCartItem(item, filial, includeProductAttributes = true) {
  const analyticsItem = {
    codigoProduto: getValue(item, ["codigoProduto", "codigo", "produto_codigo"]).toString(),
    titulo: getValue(item, ["titulo", "vcTitulo", "descricao"]),
    preco: getPreco(item),
    quantidade: getQuantidade(item),
    filial: getFilial(getValue(item, ["filial", "cd_filial", "codigo_filial"], filial))
  };

  if (includeProductAttributes) {
    analyticsItem.marca = getValue(item, ["marca", "ds_marca"]);
    analyticsItem.categoria = getValue(item, ["categoria", "ds_categoria"]);
  }

  return analyticsItem;
}

function buildCartPayload(items, filial, user, includeProductAttributes = false) {
  const analyticsItems = (items || []).map(item =>
    buildCartItem(item, filial, includeProductAttributes)
  );
  const valorTotal = analyticsItems.reduce((total, item) => {
    return total + item.preco * item.quantidade;
  }, 0);

  return {
    valorTotal,
    itens: analyticsItems,
    usuario: user
  };
}

export default {
  buildClickEvent,

  trackLogin(user) {
    const usuario = getUser(user);
    if (!usuario) return;

    send("enviarEventoLogin", { usuario });
  },

  trackSearch(termo, store) {
    send("enviarEventoBusca", {
      termo,
      usuario: getUser(store)
    });
  },

  trackViewItemList(items, store) {
    const payload = {
      idLista: LISTA_BUSCA_ID,
      nomeLista: NOME_LISTA_VISUALIZADA,
      itens: (items || []).map(item => buildCatalogItem(item)),
      usuario: getUser(store)
    };

    if (payload.itens.length > 0) {
      send("enviarEventoListaItensVisualizado", payload);
    }
  },

  trackSelectItem(item, store) {
    send("enviarEventoItemSelecionado", {
      idLista: LISTA_BUSCA_ID,
      nomeLista: NOME_ITEM_SELECIONADO,
      itens: [buildCatalogItem(item)],
      usuario: getUser(store)
    });
  },

  trackViewItem(item, store) {
    send("enviarEventoItemVisualizado", {
      itens: [buildCatalogItem(item)],
      usuario: getUser(store)
    });
  },

  trackAddToCart(item, filial, store) {
    const payload = buildCartPayload(
      [item],
      filial,
      getUser(store),
      true
    );

    send("enviarEventoCarrinhoAdicionado", payload);
  },

  trackRemoveFromCart(item, filial, store) {
    const payload = buildCartPayload(
      [item],
      filial,
      getUser(store),
      true
    );

    send("enviarEventoCarrinhoRemovido", payload);
  },

  trackViewCart(items, filial, store) {
    const payload = buildCartPayload(items, filial, getUser(store));

    if (payload.itens.length > 0) {
      send("enviarEventoCarrinhoVisualizado", payload);
    }
  },

  trackPurchase(pedido, store) {
    const payload = buildCartPayload(
      pedido.itens,
      pedido.cd_filial,
      getUser(store)
    );

    payload.idPedido = (pedido.idPedido || pedido.codigo || "").toString();

    if (payload.itens.length == 0) {
      payload.valorTotal = toNumber(pedido.valor_total || pedido.valorTotal);
    }

    send("enviarEventoCompra", payload);
  }
};
